import React, { useEffect, useRef, useState } from 'react';
import LoadingMC from '../../../../components/LoadingMC';

// Import and configure pdfjs
const pdfjs = require('pdfjs-dist/legacy/build/pdf');

pdfjs.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
  new Blob(
    [`importScripts('${require('pdfjs-dist/legacy/build/pdf.worker.mjs')}');`],
    { type: 'application/javascript' }
  )
);

const PreviewPdfInstruction = ({
  loadedFile,
  onError,
  imageClassName = 'tw-w-[40px] tw-h-[40px] tw-object-cover'
}) => {
  const [fileToImage, setFileToImage] = useState(null);
  const [failed, setFailed] = useState(false);
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    if (!loadedFile) return undefined;

    let cancelled = false;
    const isBlobUrl = loadedFile.startsWith('blob:');
    const renderWithPdfJs = isBlobUrl || typeof onErrorRef.current === 'function';

    const renderPDFToCanvas = async (pdfUrl, pageNum, canvasElement) => {
      const loadingTask = pdfjs.getDocument(pdfUrl);
      const pdfDocument = await loadingTask.promise;

      const page = await pdfDocument.getPage(pageNum);

      const viewport = page.getViewport({ scale: 0.5 });
      canvasElement.width = viewport.width;
      canvasElement.height = viewport.height;

      const canvasContext = canvasElement.getContext('2d');
      const renderContext = {
        canvasContext,
        viewport
      };

      await page.render(renderContext).promise;
    };

    const markFailed = () => {
      if (cancelled) return;
      setFileToImage(null);
      setFailed(true);
      if (onErrorRef.current) onErrorRef.current();
    };

    const convertPdfFileToImage = async () => {
      const canvasElement = document.createElement('canvas');
      try {
        await renderPDFToCanvas(loadedFile, 1, canvasElement);
        if (cancelled) return;
        setFileToImage(canvasElement.toDataURL('image/png'));
        setFailed(false);
      } catch {
        markFailed();
      } finally {
        canvasElement.width = 0;
        canvasElement.height = 0;
      }
    };

    setFileToImage(null);
    setFailed(false);

    if (!renderWithPdfJs) {
      setFileToImage(loadedFile);
      return undefined;
    }

    convertPdfFileToImage();

    return () => {
      cancelled = true;
    };
  }, [loadedFile]);

  if (failed || !loadedFile) return null;

  return fileToImage ? (
    <img
      src={fileToImage}
      alt="PDF Preview"
      className={imageClassName}
    />
  ) : (
    <p>
      <LoadingMC loading />
    </p>
  );
};

export default PreviewPdfInstruction;
